import React from 'react';
import DOMPurify from 'dompurify';
export function sanitizeHtml(html) {
    if (!html)
        return '';
    return DOMPurify.sanitize(html, {
        USE_PROFILES: { html: true },
    });
}
export const SafeHtml = ({ as = 'div', html, ...props }) => React.createElement(as, {
    ...props,
    dangerouslySetInnerHTML: { __html: sanitizeHtml(html) },
});
